<template>
  <div class="carousel-container">
    <el-carousel 
       arrow='never' 
      :height="`${Height}px`" 
      trigger="click">
      <el-carousel-item>
        <div class="small">
          <svg-icon name='Avatar' class="avatar"></svg-icon>
          <div class="company">
            <div class="company-name">KEB Transport LLC</div>
            <div class="company-name-boos">Ryan Gosich, Founder</div>
          </div>
          <div class="star"> <svg-icon name='five-star' style="width: 104px; height: 16px;"></svg-icon> </div>
          <div class="company-title">Very easy to use!</div>
          <div class="company-describe">
            Really smooth interface and allows me to see all my drivers at a glance, and send them trips with fuel stops in our network. This was able to save our team real money and time.
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="small">
          <svg-icon name='Avatar' class="avatar"></svg-icon>
          <div class="company">
            <div class="company-name">Green Line Transport LLC</div>
            <div class="company-name-boos">Gary Toz, Manager</div>
          </div>
          <div class="star"> <svg-icon name='five-star' style="width: 104px; height: 16px;"></svg-icon> </div>
          <div class="company-title">Easy setup</div>
          <div class="company-describe">
           My drivers already use Trucker Path, so there was no friction in getting them setup, and I’m able to dispatch loads to my drivers knowing they get truck safe routes. No regrets and I definitely recommend this system.
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="small">
          <svg-icon name='Avatar' class="avatar"></svg-icon>
          <div class="company">
            <div class="company-name">Swathmore and Brothers LLC</div>
            <div class="company-name-boos">Kevin Swathmore, Founder</div>
          </div>
          <div class="star"> <svg-icon name='five-star' style="width: 104px; height: 16px;"></svg-icon> </div>
          <div class="company-title">Real all-in-one platform</div>
          <div class="company-describe">
            Saved my drivers having to switch around 7 different apps just to drive a load. Most companies say they do it all, but this is the real deal here.
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'full-carousel',
  props: {
    Height: {
      type: Number,
      default: 452
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.avatar {
  width: 40px;
  height: 40px;
}
.star {
  margin-top: 32px;
}
.company {
  &-name {
    margin-top: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    font-family: OpenSans;
  }
  &-name-boos {
    margin-top: 2px;
    font-family: OpenSans;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #4C556C;
  }
}
.company-title {
  margin: 12px 0;
  font-family: OpenSans;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
}
.company-describe {
  font-family: OpenSans;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  width: 250px;
  color: #4C556C;
}
/deep/ .el-carousel {
  border-bottom-left-radius: 2%;
  &__item {
    background: #F5F7FA;
  }
  &__indicators { 
    display: flex;
    position: absolute;
    left: 24px;
    bottom: 32px;
    transform: translateX(0);
    li {
      width: 8px;
      height: 8px;
      padding: 0;
      margin-right: 12px;
      border-radius: 50%;
      background: #DADCE1;
    }
    .is-active {
      background: #4066D4;
    }
    button {
      display: none;
    }
  }
}
.small {
  padding: 32px 20px;
}
</style>